export enum AuthOptions {
  LOGGED_IN,
  LOGGED_OUT,
  INTERACTION_REQUIRED,
  INTERACTION_IN_PROGRESS,
  ERROR,
}

export interface AuthState {
  state: AuthOptions;
  accessToken?: string | null;
  error?: string | Error | undefined;
  userInfo?: { name?: string; email?: string };
}

export interface GraphAuthConfig {
  tenantId: string;
  clientId: string;
  redirectUri: string;
  scopes: string[];
  storageKeyPrefix?: string;
}
